import { Hero } from "../components/home/Hero";
import { Pathways } from "../components/home/Pathways";
import { GrowthFactorFeature } from "../components/home/GrowthFactorFeature";
import { MeetDrIrma } from "../components/home/MeetDrIrma";
import { HowWeWork } from "../components/home/HowWeWork";
import { Engagements } from "../components/home/Engagements";
import { BlogTeaser } from "../components/blog/BlogTeaser";
import { CoffeeSection } from "../components/home/CoffeeSection";

export default function HomePage() {
  return (
    <main>
      <Hero />
      <Pathways />
      <GrowthFactorFeature />
      <MeetDrIrma />
      <HowWeWork />
      <Engagements />
      <BlogTeaser
        eyebrow="Coffee With Dr. Irma · Growth"
        title="Insights for"
        titleAccent="builders."
        vertical="consulting"
        channel="coffee-growth"
        basePath="/consulting/insights"
        linkLabel="All insights"
        testId="consulting-insights-teaser"
        bg="bg-white"
      />
      <CoffeeSection />
    </main>
  );
}
